<template>
  <div class="base-Layout fill-height">
    <v-toolbar
      v-if="
        toolbarActive || ['sm', 'xs', 'md'].includes($vuetify.breakpoint.name)
      "
      :absolute="true"
      :height="88"
      :class="toolbarClass"
      app
      flat
    >
      <v-btn
        v-if="
          ['md', 'sm', 'xs'].includes($vuetify.breakpoint.name) && routerBack
        "
        @click="$store.commit('SET_PANEL_LEFT_DRAWER', true)"
        icon
        class="mr-3"
      >
        <icon-bars v-if="routerBack"></icon-bars>
      </v-btn>
      <slot name="toolbarBase"></slot>
    </v-toolbar>

    <v-content class="fill-height">
      <!-- Основной контент -->
      <div class="fill-height">
        <slot></slot>
      </div>
    </v-content>

    <v-dialog v-model="dialog" width="500"></v-dialog>
  </div>
</template>

<script>
import IconBars from "../icon/IconBars.vue";

export default {
  name: "BaseLayout",

  components: { IconBars },

  props: {
    // вкл./выкл основного toolbar
    toolbarActive: {
      type: Boolean,
      default: false
    },
    // доп.класс стилей для toolbar
    toolbarClass: {
      type: String,
      default: ""
    },
    // блок с основным контентом во всю высоту экрана
    contentFillHeight: {
      type: Boolean,
      default: true
    },
    // вкл/выкл иконки меню
    routerBack: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    dialog: false
  }),

  computed: {}
};
</script>
